import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
import { ComponentClass } from 'conversional-theme';
import { JourneysSelectors, useAppSelector } from 'conversional-journey';
import { stringUtils } from 'conversional-utils';
import { getStyles } from './QuestionTextBox.styles';
var QuestionTextBox = function (_a) {
    var _b;
    var beforeContent = _a.beforeContent, children = _a.children, consultant = _a.consultant, footer = _a.footer, header = _a.header, main = _a.main, styles = _a.styles, headerStyles = _a.headerStyles, mainStyles = _a.mainStyles;
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var classes = getStyles(theme);
    var generateHeader = function () {
        if (header && Array.isArray(header)) {
            return header.map(function (line, index) {
                return (_jsx("span", { className: classes.multiline, children: line }, "".concat(line, "-").concat(index)));
            });
        }
        return header;
    };
    return (_jsxs("div", { className: classNames(classes.container, ComponentClass(styles), (_b = {},
            _b[classes.standaloneContainer] = !consultant,
            _b)), children: [beforeContent, !stringUtils.isEmptyString(header) && _jsx("div", { className: classNames(classes.header, ComponentClass(headerStyles)), children: generateHeader() }), !stringUtils.isEmptyString(main) && _jsxs("div", { className: classNames(classes.main, ComponentClass(mainStyles)), children: [" ", main] }), !stringUtils.isEmptyString(footer) && _jsx("div", { className: classes.footer, children: footer }), children] }));
};
export default QuestionTextBox;
